import { CloseSharp } from "@mui/icons-material";
import { Autocomplete, Box, Button, FormLabel, MenuItem, Select, Stack, TextField } from '@mui/material';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import Typography from '@mui/material/Typography';
import { styled } from '@mui/material/styles';
import { Form, Formik } from 'formik';
import { useDispatch, useSelector } from 'react-redux';
import { subscriptionPayment } from "../../pages/subscriptions/action";
import Schema from "../../schema";
import NumberInput from "../inputs/normalInput/number";
import BrandAutoCompleteDropdown from "../../pages/company-wishlist/BrandAutoCompleteDropdown";
import { getAllBrandsforListing } from "../../pages/brands/action";
import { useEffect, useState } from "react";
import CustomTextArea from "../inputs/textarea";
// import instagramIcon from '../assets/images/icons/instaIcon.svg'
import instagramIcon from '../../assets/images/icons/instaIcon.svg'
import youTubeIcon from '../../assets/images/icons/YouTube2.svg'
import { createWishlist } from "../../pages/company-wishlist/action";
import { addEditWishlistReducer } from "../../pages/company-wishlist/addEditWishlistSlice";
import trashGif from '../../assets/images/icons/trash.gif'
const ConfirmationModal = (props) => {
    const { open, setOpen,handleClick,title,subHeading,logo,mainHeadingColor,height } = props;
    const handleClose = () => setOpen(false);
    const BootstrapDialog = styled(Dialog)(({ theme }) => ({
        '& .MuiPaper-root': {
            width: '450px',
            maxWidth:'1000px !important',
            height: height ? height : '250px',
            padding: '24px',
            BorderRadius: '16px',
        },
        '& .MuiDialogContent-root': {
            padding: theme.spacing(2),
        },
        '& .MuiDialogActions-root': {
            padding: theme.spacing(1),
        },
    }));
  return (
    <BootstrapDialog
    onClose={handleClose}
    aria-labelledby="customized-dialog-title"
    open={open}>
    {/* <Stack
                        sx={{
                            border: '0px solid red'
                        }}
                        direction="row"
                        justifyContent={"space-between"}
                        alignItems={"center"}>

                        <Typography
                            sx={{ fontSize: '24px', fontWeight: '600', color: '#000' }}
                            id="customized-dialog-title">
                            {title}
                        </Typography>
                        <div className="cursorPointer" onClick={handleClose}>
                            <CloseSharp sx={{ color: "#000", fontSize: '20px', fontWeight: '600' }} />
                        </div>
                    </Stack> */}
                    <Stack direction="column" gap={3} justifyContent="center" alignItems="center">
                        <img src={logo} alt="trashGif" style={{height:'40px',width:'40px'}}/>
                        <Box sx={{textAlign:'center'}}>
                        <Typography sx={{fontWeight:'700',fontSize:'16px',color:mainHeadingColor}}>{title}</Typography>
                        <Typography sx={{fontWeight:'400',fontSize:'14px',color:'#433E3F',marginTop:'10px'}}>{subHeading}</Typography>
                        </Box>
                        <Stack direction="row" justifyContent="space-between" sx={{width:'100%'}}>
                            <Button sx={{"&:hover":{background:'#B5B3B3',color:'white',border:'0px'},padding:'12px 10px',width:'164px',height:'43px',borderRadius:'6px',fontSize:'14px',fontWeight:'400',color:'white',background:'#B5B3B3'}} onClick={handleClose}>Cancel</Button>
                            <Button sx={{"&:hover":{background:'var(--color-blue)',color:'white',border:'0px'},padding:'12px 10px',width:'164px',height:'43px',borderRadius:'6px',fontSize:'14px',fontWeight:'400',color:'white',background:'var(--color-blue)'}} onClick={handleClick}>Done</Button>
                        </Stack>
                    </Stack>
        </BootstrapDialog>
  )
}

export default ConfirmationModal;